export default "__VITE_ASSET__CEg5WmYX__"